import api from "../api/api";
import endpoint from "../api/endpoints";

import { filterPromotionsByCustomerId } from "./promotionFilterUtil";

/**
 * Fetches product details for cart items and merges them with cart data
 * @param {Array} cartItems - Array of cart items with basic info (id, quantity, selected, etc.)
 * @returns {Promise<Array>} - Array of cart items merged with full product details
 */
export const fetchCartDetails = async (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    return [];
  }

  try {
    const cartItemIds = cartItems.map((item) => item.id);
    const response = await api.post(endpoint.POST_GET_ITEM_BY_IDS(), {
      ids: cartItemIds,
    });

    // Filter promotions based on customer category
    const productDetails = filterPromotionsByCustomerId(response.data || []);

    // Merge cart items with product details
    const mergedCartDetails = cartItems.map((cartItem) => {
      const productDetail = productDetails.find(
        (product) => product.id === cartItem.id
      );
      return {
        ...cartItem, // Cart item properties (id, quantity, selected, subscription settings)
        ...productDetail, // Product details (itemid, displayname, file_url, price, pricing, etc.)
        isAvailable: !!productDetail, // Flag to indicate if product details were found
      };
    });

    return mergedCartDetails;
  } catch (error) {
    // Fallback to cart items without details if API call fails
    return cartItems;
  }
};
